<template>
  <VDataGridV2
    id="drivers-registry"
    entity-type="driver"
    :loader="loader"
    :context-menu="DriversService.contextMenu"
    @row:dblclick="openCard"
  >
    <VDataGridColumnV2
      id="isFavorite"
      width="52px"
      content-align="center"
    >
      <template #default="{ row }">
        <VButton
          theme="link"
          class="favorite"
          :title="DriversService.getFavoriteTitle(row)"
          :material="DriversService.getFavoriteIcon(row)"
          hover-material="star"
          @dblclick.stop
          @click="toggleFavorite(row)"
        />
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="id"
      width="75px"
      content-align="left"
      label="№"
    >
      <template #default="{ row }">
        <VLink @click="openCard(row)">{{ row.id }}</VLink>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="name"
      width="300px"
      content-align="left"
      content-class="ellipsis"
      label="Водитель"
      filterable
      filter-send-name="pattern"
      :filter-props="{
        placeholder: 'Фио водителя или госномер',
        clearable:   true,
      }"
    >
      <template #default="{ row }">
        <div
          class="ellipsis"
          :title="row.name"
        >
          {{ row.name }}
        </div>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="registrationNumber"
      width="150px"
      content-align="left"
      content-class="ellipsis nowrap"
      label="Госномер"
    >
      <template #default="{ row }">
        <div
          :title="row.registrationNumber"
          class="ellipsis nowrap"
        >
          {{ row.registrationNumber ?? '--' }}
        </div>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="vehicle"
      width="250px"
      content-align="left"
      content-class="ellipsis"
      label="Модель машины"
    >
      <template #default="{ row }">
        <div
          class="ellipsis"
          :title="row.vehicle?.name"
        >
          {{ row.vehicle?.name ?? '--' }}
        </div>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="averageRate"
      width="190px"
      content-align="center"
      content-class="nowrap"
      label="Рейтинг"
    >
      <template #default="{ row }">
        <div class="rating">
          <span
            v-if="$core.utils.isNullOrUndefined(row.averageRate) === false"
            class="stars"
          >
            <VIcon
              v-for="star in 5"
              :key="star"
              class="star"
              :material="DriversService.getRateStarIcon(row.averageRate, star)"
            />
          </span>
          {{ row.averageRateString }}
        </div>
      </template>
    </VDataGridColumnV2>

    <VDataGridActionBarV2>
      <VButton
        theme="primary"
        @click="openCard()"
      >
        Добавить водителя
      </VButton>
    </VDataGridActionBarV2>
  </VDataGridV2>
</template>

<style lang="scss" src="./DriversRegistry.scss"/>

<script lang="ts">

import DataGridLoader from '@/lib/components/VDataGridV2/DataGridLoader';
import Driver         from '@/domains/Drivers/Driver';
import DriversService from '@/domains/Drivers/DriversService';

export default defineComponent({
  name: 'DriversRegistry',

  setup() {
    return {
      DriversService,
    };
  },

  data() {
    return {
      loader: new DataGridLoader(DriversService.getListPaginated),
    };
  },

  methods: {
    async openCard(driver?: Driver): Promise<void> {
      if (await DriversService.showDriverCard(driver ?? null) === true) {
        await this.loader.refresh();
      }
    },

    /** Избранный у пользователя один — после отметки звезда снимается с прежнего, поэтому перечитываем реестр */
    async toggleFavorite(driver: Driver): Promise<void> {
      if (await DriversService.toggleFavorite(driver) === true) {
        await this.loader.refresh();
      }
    },
  },
});
</script>
